// API基础URL
const API_BASE_URL = 'http://localhost:3001/api';
// 上线后改为你的域名
// const API_BASE_URL = 'https://hugtub.cn/api';

// 用户登录
export const login = async (phone, password) => {
  // 临时模拟API响应
  if (password === 'dthugtub') {
    return {
      success: true,
      user: {
        userId: 'dev_' + Date.now(),
        username: 'DeveloperTest',
        phone: phone,
        avatar: '/images/profile.jpg',
        loginType: 'phone',
        createdAt: new Date().toISOString(),
        isDeveloper: true,
        experience: 0,
        level: 1
      }
    };
  }
  
  return { 
    success: false, 
    error: '内测阶段，暂不支持普通用户登录' 
  };
  
  // 实际API调用代码（后端准备好后使用）
  /*
  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phone, password })
    });
    
    return await response.json();
  } catch (error) {
    console.error('登录请求失败:', error);
    return { success: false, error: '网络错误，请稍后再试' };
  }
  */
};

// 用户签到
export const signIn = async (userId) => {
  // 临时模拟API响应
  const currentExp = parseInt(localStorage.getItem('userExp') || '0');
  const currentLevel = parseInt(localStorage.getItem('userLevel') || '1');
  
  let newExp = currentExp + 10;
  let newLevel = currentLevel;
  
  if (newExp >= 100) {
    newExp = newExp - 100;
    newLevel = currentLevel + 1;
  }
  
  return {
    success: true,
    experience: newExp,
    level: newLevel
  };
  
  // 实际API调用代码（后端准备好后使用）
  /*
  try {
    const response = await fetch(`${API_BASE_URL}/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId })
    });
    
    return await response.json();
  } catch (error) {
    console.error('签到请求失败:', error);
    return { success: false, error: '网络错误，请稍后再试' };
  }
  */
};

// 获取用户信息
export const getUserInfo = async (userId) => {
  // 临时模拟API响应
  const user = getUserFromLocalStorage();
  if (user && user.userId === userId) {
    return {
      success: true,
      user: {
        ...user,
        experience: parseInt(localStorage.getItem('userExp') || '0'),
        level: parseInt(localStorage.getItem('userLevel') || '1'),
        lastSignInDate: localStorage.getItem('lastSignInDate') || ''
      }
    };
  }
  
  return { success: false, error: '用户不存在' };
  
  // 实际API调用代码（后端准备好后使用）
  /*
  try {
    const response = await fetch(`${API_BASE_URL}/user/${userId}`);
    return await response.json();
  } catch (error) {
    console.error('获取用户信息失败:', error);
    return { success: false, error: '网络错误，请稍后再试' };
  }
  */
};

// 保存用户到本地存储
export const saveUserToLocalStorage = (userData) => {
  localStorage.setItem('hugtub_user', JSON.stringify(userData));
  
  // 如果是首次登录，初始化用户数据
  const userDataKey = `hugtub_data_${userData.userId}`;
  if (!localStorage.getItem(userDataKey)) {
    // 为新用户创建默认数据
    const initialData = {
      posts: [],
      favorites: [],
      settings: {
        theme: 'default',
        notifications: true
      },
      lastLogin: new Date().toISOString()
    };
    localStorage.setItem(userDataKey, JSON.stringify(initialData));
    console.log('已为新用户创建数据', userData.userId);
  }
};

// 从本地存储获取用户
export const getUserFromLocalStorage = () => {
  const userJson = localStorage.getItem('hugtub_user');
  if (userJson) {
    try {
      return JSON.parse(userJson);
    } catch (e) {
      console.error('解析用户数据失败', e);
      return null;
    }
  }
  return null;
}; 